<fgb-banner title="{{ 'auctions.page.title' | translate }}" class="d-lg-flex d-none"></fgb-banner>

<div class="d-block d-lg-none">
  <fgb-mobile-page-header
    pageTitle="rewards.page.title"
    [showFooter]="true"
    [showQr]="true"
    [backButtonLink]="'/'"
  ></fgb-mobile-page-header>
</div>

<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

<div class="container mt-4" [ngClass]="isCorporate ? 'corporate-colors' : 'default-color'">
  <fgbcl-auction-list [defaultSort]="0"></fgbcl-auction-list>
</div>
